// #imagine-red — lazy-load background video + scroll reveal
// Both the iframe and the YouTube API are deferred until the section enters the viewport.
(function () {
    var sec = document.getElementById('imagine-red');
    if (!sec) return;

    var videoLoaded = false;

    function injectVideo() {
        if (videoLoaded) return;
        videoLoaded = true;

        var bg = sec.querySelector('.ired-video-bg');
        if (!bg) return;

        var iframe = document.createElement('iframe');
        iframe.id = 'ired-yt-player';
        iframe.src = 'https://www.youtube.com/embed/N4w3hesyBuE?autoplay=1&mute=1&loop=1&playlist=N4w3hesyBuE&controls=0&disablekb=1&rel=0&modestbranding=1&playsinline=1&iv_load_policy=3&enablejsapi=1&fs=0&color=white';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
        iframe.setAttribute('title', 'Background video');
        iframe.style.cssText = 'pointer-events:none;position:absolute;height:56.25vw;left:50%;min-height:100%;min-width:177.78vh;top:50%;transform:translate(-50%,-50%);width:100vw;';
        bg.insertBefore(iframe, bg.firstChild);

        var player;

        function forcePlay() {
            try { player.seekTo(0); player.playVideo(); } catch (e) {}
        }

        window.onYouTubeIframeAPIReady = function () {
            player = new YT.Player('ired-yt-player', {
                events: {
                    onReady: function () { player.playVideo(); },
                    onStateChange: function (e) {
                        if (e.data === 0) { forcePlay(); }
                    }
                }
            });
        };

        // fallback in case the ended state is missed
        setInterval(function () {
            try { if (player.getPlayerState() === 0) { forcePlay(); } } catch (e) {}
        }, 2000);

        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
    }

    var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        injectVideo();
        sec.classList.add('ired-revealed');
        io.disconnect();
    }, { threshold: 0.15 });
    io.observe(sec);
}());

// Product sheet spec-item accordion — 1-line preview, click to expand/collapse
document.querySelectorAll('.product-sheet__spec-trigger[data-has-desc="true"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
        btn.closest('.product-sheet__spec-item').classList.toggle('is-open');
    });
});

// Gallery lightbox (ps-lightbox)
(function () {
    var lb = document.getElementById('ps-lightbox');
    if (!lb) return;
    var lbImg  = lb.querySelector('.ps-lightbox__img');
    var thumbs = lb.querySelector('.ps-lightbox__thumbs');
    var imgs   = [];
    var current = 0;

    function show(i) {
        current = (i + imgs.length) % imgs.length;
        lbImg.src = imgs[current].src;
        lbImg.alt = imgs[current].alt || '';
        lb.querySelectorAll('.ps-lightbox__thumb').forEach(function (t, ti) {
            t.classList.toggle('is-active', ti === current);
        });
    }

    function open(data, startIdx) {
        imgs = data;
        thumbs.innerHTML = '';
        data.forEach(function (img, i) {
            var t = document.createElement('img');
            t.src = img.thumb || img.src;
            t.alt = img.alt || '';
            t.className = 'ps-lightbox__thumb';
            t.addEventListener('click', function () { show(i); });
            thumbs.appendChild(t);
        });
        show(startIdx || 0);
        lb.classList.add('is-open');
        document.body.style.overflow = 'hidden';
    }

    function close() {
        lb.classList.remove('is-open');
        lbImg.src = '';
        document.body.style.overflow = '';
    }

    document.querySelectorAll('.ps-gallery-open').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var data = JSON.parse(this.dataset.psImgs || '[]');
            open(data, 0);
        });
    });

    lb.querySelector('.ps-lightbox__close').addEventListener('click', close);
    lb.querySelector('.ps-lightbox__prev').addEventListener('click', function () { show(current - 1); });
    lb.querySelector('.ps-lightbox__next').addEventListener('click', function () { show(current + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape')     close();
        if (e.key === 'ArrowLeft')  show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
    });
}());

// #why-beyond — "Read More / Read Less" toggle
(function () {
    var btn  = document.getElementById('why-read-more-btn');
    var body = document.getElementById('why-read-more-body');
    if (!btn || !body) return;

    btn.addEventListener('click', function () {
        var open = body.style.display !== 'none' && body.style.display !== '';
        body.style.display = open ? 'none' : 'block';
        btn.textContent    = open ? 'Read More ↓' : 'Read Less ↑';
    });

    btn.addEventListener('mouseover', function () {
        btn.style.borderColor = '#ff1514';
        btn.style.color       = '#ff1514';
    });
    btn.addEventListener('mouseout', function () {
        btn.style.borderColor = 'rgba(255,255,255,.3)';
        btn.style.color       = '#fff';
    });
}());

// Video testimonial lightbox (hn-lightbox)
(function () {
    var lightbox = document.getElementById('hn-lightbox');
    var video    = document.getElementById('hn-video');
    var closeBtn = document.getElementById('hn-close');
    if (!lightbox || !video || !closeBtn) return;

    document.querySelectorAll('.hn-video-thumbnail').forEach(function (el) {
        el.addEventListener('click', function () {
            video.src = 'https://www.youtube.com/embed/' + this.dataset.videoId + '?modestbranding=1&rel=0&autoplay=1';
            lightbox.style.display = 'flex';
        });
    });

    function closeLb() { lightbox.style.display = 'none'; video.src = ''; }
    closeBtn.addEventListener('click', closeLb);
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLb(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
}());

